export const jsonToFormData = (json: Record<string, any>) => {
  const formData = new FormData();

  for (const key in json) {
    if (json[key as any as keyof typeof json] === undefined) continue;

    const value = json[key as keyof typeof json]!;
    if (Array.isArray(value)) {
      for (let i = 0; i < value.length; i++) {
        formData.append(
          key,
          (typeof value[i] === "string"
            ? value[i]
            : JSON.stringify(value[i])) as any
        );
      }
    } else {
      formData.append(
        key,
        typeof value === "string" ? value : JSON.stringify(value)
      );
    }
  }

  return formData;
};
